import { type NodeOrFn, renderNodeOrFn } from "@mdotm/shadcn/legacy/react-extensions";
import { type ReactNode, createContext, useContext, useMemo, useState } from "react";

export type PageCtx = {
	titleActionPortalTarget: HTMLDivElement | null;
	setTitleActionPortalTarget: (el: HTMLDivElement | null) => void;
};
export const PageCtx = createContext<PageCtx | null>(null);

export function PageCtxProvider(props: { children: ReactNode }): React.JSX.Element {
	const [titleActionPortalTarget, setTitleActionPortalTarget] = useState<HTMLDivElement | null>(null);
	const ctx = useMemo(
		() => ({
			titleActionPortalTarget,
			setTitleActionPortalTarget,
		}),
		[titleActionPortalTarget],
	);

	return <PageCtx.Provider value={ctx}>{props.children}</PageCtx.Provider>;
}

export function PageCtxConsumer(props: { children: NodeOrFn<PageCtx> }): React.JSX.Element {
	const ctx = useContext(PageCtx);
	if (!ctx) {
		throw new Error("attempted to consume a PageCtx in a layout that doesn't provide one");
	}
	return <>{renderNodeOrFn(props.children, ctx)}</>;
}
